import { render, staticRenderFns } from "./PosBase.vue?vue&type=template&id=54caa692&scoped=true&"
import script from "./PosBase.vue?vue&type=script&lang=js&"
export * from "./PosBase.vue?vue&type=script&lang=js&"
import style0 from "./PosBase.vue?vue&type=style&index=0&id=54caa692&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54caa692",
  null
  
)

export default component.exports